<template>
  <tr @click="select()">
    <td>
      <span class="brand">{{ product.brand }}</span>
      <h4>{{ product.name }}</h4>
      <code>{{ product.upc_13 }}</code>
    </td>
    <td class="price">
      {{ product.srp_amount | money }} /
      {{ product.unit_of_measure | unit-of-measure 1 true }}
    </td>
  </tr>
</template>

<script>
import Stash from 'src/stash';
import { Api } from 'src/utilities';

export default {
  props: [
    {
      name: 'product',
      type: Object,
      default: {},
    },
  ],

  methods: {
    select() {
      Api.get(`products/${this.product.id}`, {
        channel: 'foreground',
        params: { include: 'facets' },
      }).then(response => Stash.setProduct(response.data));
    },
  },
};
</script>

<style scoped>
.price {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// Product.vue?7c99b436